import type { ModalTypes } from '@fiverr-private/overlay';
import { TOP_GROUPING } from '../../../../config/filters';

export const FILTERS_MODAL_SIZE: ModalTypes.ModalSize = 'xl';

export const FILTERS_MODAL_FULL_SCREEN_BREAKPOINT = 'md';

export const FILTERS_MODAL_TRACKING_SOURCE = 'modal';

export const MODAL_COLLECTION_IDS = {
    BUDGET_AND_TIMELINE: 'budget-and-timeline',
    FREELANCER_PREFERENCES: 'freelancer-preferences',
    CATEGORIES: 'categories',
    SERVICE_OPTIONS: 'service-options',
} as const;

export const MODAL_SECTION_ORDER = [
    {
        id: MODAL_COLLECTION_IDS.BUDGET_AND_TIMELINE,
        titleKey: 'search_perseus.side_filters.collections.budget_and_timeline.alias',
        topGrouping: TOP_GROUPING.BUDGET,
    },
    {
        id: MODAL_COLLECTION_IDS.FREELANCER_PREFERENCES,
        titleKey: 'search_perseus.side_filters.collections.freelancer_preferences.alias',
        topGrouping: TOP_GROUPING.SELLER,
    },
    {
        id: MODAL_COLLECTION_IDS.CATEGORIES,
        titleKey: 'search_perseus.side_filters.collections.categories.alias',
        topGrouping: TOP_GROUPING.CATEGORY,
    },
    {
        id: MODAL_COLLECTION_IDS.SERVICE_OPTIONS,
        titleKey: 'search_perseus.side_filters.collections.service_options.alias',
        topGrouping: TOP_GROUPING.SERVICE,
    },
] as const;
